export interface IMessagesState {
  count: number;
  status?: EUnreadMessagesStatus;
  activeRequestId?: number;
}

export enum EUnreadMessagesStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}
